import React, { useContext, useState } from "react";
import "../../Tabels/Tabels.css";
import { Link } from "react-router-dom";
import { Context } from "../../../utils/context";
import ModalSave from "../../common/ModelSave";
import { CancelButton, SaveButton } from "../../common/Button";
import { Row, Form, Modal } from "react-bootstrap";
import { useForm } from "react-hook-form";
import CareerFields, { ImageField, buildCareerFormData, useCareerOptions } from "./CareerFields";

// Always returns plain text, even when the API sends back a database error object
const messageOf = (res) => {
  if (res?.success) return typeof res?.message === "string" ? res.message : "Saved";
  const e = res?.errors ?? res?.message;
  if (typeof e === "string") return e;
  return (
    e?.original?.sqlMessage ||
    e?.parent?.sqlMessage ||
    e?.message ||
    (typeof res?.message === "string" ? res.message : "") ||
    "Something went wrong"
  );
};

const AddOffCanvance = (props) => {
  const { postData } = useContext(Context);
  const [showModal, setShowModal] = useState({ code: 0, message: "" });
  const { options, today } = useCareerOptions();

  const {
    control,
    register,
    handleSubmit,
    trigger,
    watch,
    formState: { errors },
  } = useForm();
  const f = { control, register, trigger, errors };

  const onSubmit = async (data) => {
    try {
      const response = await postData(`/admin/career/career-form`, buildCareerFormData(data));
      const ok = !!response?.success;
      setShowModal({ code: response?.code, message: messageOf(response) });
      setTimeout(() => {
        setShowModal({ code: 0, message: "" });
        if (ok) props.handleClose(); // stay open on error so nothing typed is lost
      }, ok ? 1000 : 3500);
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <>
      <Modal {...props} onHide={props.handleClose} size="lg" aria-labelledby="contained-modal-title-vcenter" centered>
        <Modal.Header closeButton>
          <Modal.Title id="contained-modal-title-vcenter">Add Career</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form onSubmit={(e) => e.preventDefault()} role="form">
            <CareerFields f={f} options={options} today={today}>
              <ImageField register={register} value={watch("image")} />
            </CareerFields>
            <Row className="mt-5 pb-3">
              <div className="d-flex justify-content-center">
                <Link>
                  <CancelButton name={"Cancel"} handleClose={props.handleClose} />
                </Link>
                <SaveButton name={"Save"} handleSubmit={handleSubmit(onSubmit)} />
              </div>
            </Row>
          </Form>
        </Modal.Body>
      </Modal>

      <ModalSave message={showModal.message} showErrorModal={showModal.code ? true : false} />
    </>
  );
};

export default AddOffCanvance;